{
    "nav__home": "Opportunités",
    "nav__draft_quotes": "Brouillons de devis",
    "nav__quotes": "Devis",
    "nav__orders": "Commandes",

    "sidebar__title_customers": "Clients",
    "sidebar__subtitle_oppertunity_count": "Clients avec opportunités",
    "sidebar__search_placeholder": "Rechercher des clients, des bons de livraison, etc.",
    "sidebar__slice_count": "ouvertes",
    "sidebar__slice_business_value": "valeur commerciale estimée",

    "header__business_value": "Volume de ventes total estimé",
    "header__count_plural": "ouvertes",
    "header__count_singular": "ouverte",

    "header__seleceted_count": "sélectionnées",

    "actions__select_all": "Tout sélectionner",
    "actions__email": "E-mail",
    "actions__task": "Tâche",
    "actions__quote": "Devis",
    "actions__order": "Commande"
}
